export default "__VITE_ASSET__B3f3khG8__"